import { UserRoleEnum } from "@nlc/shared-types";
import { useMemo } from "react";

export type ProfileTabId = "manage" | "performance" | "requests" | "team";

export interface ProfileTabDefinition {
  id: ProfileTabId;
  label: string;
}

export function useUsersTabs(roleId?: UserRoleEnum): ProfileTabDefinition[] {
  return useMemo(() => {
    if (!roleId) return [];
    const tabs: ProfileTabDefinition[] = [];

    if (roleId === UserRoleEnum.Designer) {
      tabs.push(
        { id: "requests", label: "Assigned Requests" },
        { id: "performance", label: "Performance" },
      );
    }

    if (roleId === UserRoleEnum.TeamLeader) {
      tabs.push(
        { id: "requests", label: "Assigned Requests" },
        { id: "team", label: "Team Requests" },
      );
    }

    tabs.push({ id: "manage", label: "Manage Account" });

    return tabs;
  }, [roleId]);
}
